module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"history":"Historique de l\u0027activité","loading":"Chargement...","updateFormMessage":"a modifié le formulaire."}}')
  delete Component.options._Ctor
}
